import { render } from "./OptionsDropdown.vue?vue&type=template&id=5eff6b48&scoped=true"
import script from "./OptionsDropdown.vue?vue&type=script&lang=js"
export * from "./OptionsDropdown.vue?vue&type=script&lang=js"

import "./OptionsDropdown.vue?vue&type=style&index=0&id=5eff6b48&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-5eff6b48"

export default script